/**
 * Report-ops forms stub. Same empty/not-ready contract as forms.api.js.
 */
import {
    fetchForms as fetchFormsStub,
    createForm,
    updateForm,
    deleteForm as deleteFormStub,
    getAvailableDocuments,
} from '@/lib/services/forms.api.js';
import { useFormsStore } from '@/store/forms.store.js';
import { Logger } from '@/lib/app-log.js';

export class FormsIntegration {
    async fetchForms() {
        const store = useFormsStore.getState();
        store.setLoading(true);
        store.clearError();
        try {
            const params = { ...store.searchParams, columnFilters: store.columnFilters || {} };
            const response = await fetchFormsStub(params);
            useFormsStore.setState({
                forms: response.data,
                paginationData: response.pagination,
                uniqueValues: response.uniqueValues || store.uniqueValues || {},
                loading: false,
            });
        } catch (error) {
            store.setError(error.message);
            store.setLoading(false);
            setTimeout(() => store.clearError(), 5000);
        }
    }

    async fetchAvailableDocuments() {
        const store = useFormsStore.getState();
        try {
            const documents = await getAvailableDocuments();
            store.setAvailableDocuments(documents);
        } catch (error) {
            Logger.error('Error fetching available documents:', { error: error?.message });
        }
    }

    handleSearch(searchTerm) {
        useFormsStore.getState().setSearchParams({ search: searchTerm, page: 1 });
        return this.fetchForms();
    }

    handleSort(sortBy, sortDirection) {
        useFormsStore.getState().setSearchParams({ sortBy, sortDirection });
        return this.fetchForms();
    }

    handlePageChange(page) {
        useFormsStore.getState().setSearchParams({ page });
        return this.fetchForms();
    }

    handlePageSizeChange(pageSize) {
        useFormsStore.getState().setSearchParams({ pageSize, page: 1 });
        return this.fetchForms();
    }

    async saveForm(formData) {
        const store = useFormsStore.getState();
        store.setLoading(true);
        store.clearError();
        try {
            if (formData.id) {
                await updateForm(formData.id, formData);
            } else {
                await createForm(formData);
            }
            await this.fetchForms();
            store.closeForm();
            store.setLoading(false);
        } catch (error) {
            store.setError(error.message);
            store.setLoading(false);
            setTimeout(() => store.clearError(), 5000);
        }
    }

    async deleteForm(id) {
        const store = useFormsStore.getState();
        store.setLoading(true);
        store.clearError();
        try {
            await deleteFormStub(id);
            await this.fetchForms();
            store.closeDeleteDialog();
            store.setLoading(false);
        } catch (error) {
            store.setError(error.message);
            store.setLoading(false);
            setTimeout(() => store.clearError(), 5000);
        }
    }
}
